export default __webpack_public_path__ + "static/media/WISE-ETH.b87d9908.png";